import EditAwardPage from './EditAwardPage';
export default EditAwardPage;
